/* eslint-disable @typescript-eslint/no-unsafe-assignment */
import React, { ReactElement } from "react";
import "./Schedule.css";
import { Event } from "./data";
import t from "../../helpers/i18n";

const DAY_WIDTH_PX = 792;

export default function Schedule({ events }: { events: Event[] }): ReactElement {
  const items = getScheduleItems(events);

  return (
    <div className="schedule-content">
      <div className="calendar-container">
        {items}
        <table className="timetable">
          <thead>
            <tr>
              <th></th>
              {[...Array(24)].map((_, i) => (
                <th key={i}>{i}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {[
              t("MN", "ПН"),
              t("TU", "ВТ"),
              t("WD", "СР"),
              t("TH", "ЧТ"),
              t("FR", "ПТ"),
              t("SA", "СБ"),
              t("SU", "ВС"),
            ].map((d, i) => (
              <tr key={i}>
                <td>{d}</td>
                {[...Array(24)].map((_, i) => (
                  <td key={i}></td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}

function getScheduleItems(events: Event[]): ReactElement[] {
  const result: ReactElement[] = [];
  const minutesInDay = 1440;

  for (const [i, event] of events.entries()) {
    const widthPx = (event.endMin - event.startMin) * (DAY_WIDTH_PX / minutesInDay);
    const leftPx = (event.startMin / minutesInDay) * DAY_WIDTH_PX + 32.97;

    result.push(
      <div
        key={`${i}`}
        className="item"
        style={{
          top: `${41 * (event.day + 1) + event.day}px`,
          left: `${leftPx}px`,
          width: `${widthPx}px`,
        }}
      ></div>,
    );
  }

  return result;
}
